// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"2748e939b4c96a8930ca","595":"cff2086da45bf9741100"}[chunkId] + ".js");